import "../components/facets";

import {
	compare,
	setComparables,
	getComparables,
} from "../components/comparables";

document.addEventListener("alpine:init", () => {
	// Compare Button
	Alpine.bind("compare", () => ({
		"@click.stop.prevent"() {
			compare(this.$event);
		},
	}));
});
getComparables();
window.addEventListener("get-comparables", () => {
	getComparables();
});
window.addEventListener("set-comparables", () => {
	setComparables();
});
